import { AxiosResponse } from "axios";

export const pickData = <T extends AxiosResponse>(response: T): T["data"] => {
  return response.data;
};
